import GoogleIcon from '@mui/icons-material/Google';
import { Button } from '@mui/material';
import React from 'react';
import { useUser } from '../hooks/useUser.ts';

interface GoogleSignInButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}

const GoogleSignInButton = ({ 
  variant = 'contained',
  size = 'medium',
  fullWidth = false 
}: GoogleSignInButtonProps) => {
  const { data: user, isLoading } = useUser();
  
  // Don't render if user is already authenticated or still loading
  if (user || isLoading) {
    return null;
  }
  
  const handleGoogleSignIn = () => {
    try {
      // Use the current origin and add the API prefix for authentication
      const authEndpoint = '/api/auth/google';
      
      // When in development with local servers, use the backend directly
      // This avoids React Router intercepting backend routes
      const isDevelopment = process.env.NODE_ENV === 'development';
      const endpoint = isDevelopment 
        ? `http://localhost:3001${authEndpoint}` 
        : authEndpoint;
      
      // Redirect directly to the Google OAuth flow
      window.location.href = endpoint;
    } catch (error) {
      console.error('Error signing in with Google:', error);
      alert('Failed to sign in with Google');
    }
  };
  
  return (
    <Button
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      onClick={handleGoogleSignIn}
      startIcon={<GoogleIcon />}
      sx={{
        borderRadius: '20px',
        textTransform: 'none',
        fontWeight: 500,
        backgroundColor: variant === 'contained' ? '#4285F4' : undefined,
        '&:hover': {
          backgroundColor: variant === 'contained' ? '#3367D6' : undefined,
        }
      }}
    >
      Sign in with Google
    </Button>
  );
};

export default GoogleSignInButton; 